import { Directive, Input, ElementRef, Renderer2, Inject } from '@angular/core';

import { GasDynamicComponentsService } from '@cikrf/gas-utils/services';
import { GasObjectHelper } from '@cikrf/gas-utils/helpers';

import { GasPositioningPopup } from '../../../common/gas-dynamic-positioning-popup/gas-dynamic-positioning-popup.namespace';
import { GasDynamicPositioningPopupDirective } from '../../../common/gas-dynamic-positioning-popup/gas-dynamic-positioning-popup.directive';
import { GasPositioning } from '../../../utils/gas-positioning/gas-positioning.namespace';
import { GasPositioningService } from '../../../utils/gas-positioning/gas-positioning.service';
import { GasBrowserEventsService } from '../../../utils/gas-browser-event/gas-browser-events.service';
import { GAS_POSITIONING_CONFIG } from '../../../common/gas-dynamic-positioning-popup/gas-dynamic-positioning-popup.constant';
import { GasSelectDropdownComponent } from './gas-select-dropdown.component';
import { GasSelectComponent } from '../wrapper/gas-select.component';

@Directive({
  selector: '[gasSelectDropdown]',
})
export class GasSelectDropdownDirective extends GasDynamicPositioningPopupDirective<string | number,
  GasSelectDropdownComponent> {
  @Input('gasSelectDropdown')
  public set setup(value: Omit<GasPositioningPopup.Config<GasSelectDropdownComponent>, 'component'>) {
    this.config = {
      ...this.injectionConfig,
      ...{
        preferablePositions: [
          GasPositioning.Direction.Bottom,
          GasPositioning.Direction.Top,
        ],
        offset: 0,
        arrowWidth: 0,
      },
      ...GasObjectHelper.mergeDeep(value, {
        props: {
          gasSelect: this.gasSelect,
        },
      }),
      component: GasSelectDropdownComponent,
    };
    this.nativeDisabled = value?.disabled;
  }

  /** Без модификаторов доступа, ибо они указаны в расширяемом классе */
  constructor(
    el: ElementRef,
    gasDynamicComponentsService: GasDynamicComponentsService,
    gasPositioningService: GasPositioningService,
    gasBrowserEventsService: GasBrowserEventsService,
    render: Renderer2,
    @Inject(GAS_POSITIONING_CONFIG)
    private injectionConfig: GasPositioningPopup.Config<GasSelectDropdownComponent>,
    private gasSelect: GasSelectComponent,
  ) {
    super(
      el,
      gasDynamicComponentsService,
      gasPositioningService,
      gasBrowserEventsService,
      render,
    );
  }
}
